import UpdateIcon from '@mui/icons-material/SystemUpdateAlt';

import React from 'react';

import NotificationActionButtons from './NotificationActionButtons';
import injectStores from '../RootStore/injectStores';

interface NotificationButtonInstallPwaProps {
  viewStore?: {
    reloadApp: () => void;
  };
}

const NotificationButtonInstallPwa: React.FC = injectStores(
  ({ viewStore: { reloadApp } }: NotificationButtonInstallPwaProps) => {
    return (
      <NotificationActionButtons onClick={() => reloadApp()}>
        <UpdateIcon />
      </NotificationActionButtons>
    );
  }
);

export default NotificationButtonInstallPwa;
